import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6d2082e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "alert-box" }
const _hoisted_2 = { class: "alert" }
const _hoisted_3 = { class: "buttons" }

import { useAlertBox } from '.'

export default /*#__PURE__*/_defineComponent({
  __name: 'AlertBox',
  setup(__props) {

const { alertBox } = useAlertBox()
const { message, buttons, visible, dismiss } = alertBox

return (_ctx: any,_cache: any) => {
  const _component_CButton = _resolveComponent("CButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(visible))
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "wrapper",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(dismiss) && _unref(dismiss)(...args)))
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createTextVNode(_toDisplayString(_unref(message)) + " ", 1),
            _createElementVNode("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(buttons), (button, index) => {
                return (_openBlock(), _createBlock(_component_CButton, {
                  key: index,
                  class: _normalizeClass(button.class),
                  onClick: ($event: any) => {button.handler();_unref(dismiss)()}
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(button.text), 1)
                  ]),
                  _: 2
                }, 1032, ["class", "onClick"]))
              }), 128))
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})